import React, { memo } from 'react';
import { Button as AntButton, ButtonProps, Flex, Spin } from 'antd';
import { createUseStyles } from 'react-jss';
import { COLORS, useThemes } from 'core';
import { LoadingOutlined } from '@ant-design/icons';

const useStyle = createUseStyles<string, unknown, COLORS>(
  (colors) => ({
    button: {
      backgroundColor: colors.theme01,
      color: colors.white01,
      height: '30px',
      flex: 1,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '5px',
      marginTop: '5px',
      marginRight: 5,
      marginLeft: 5,
      border: 'none',
      outlineWidth: 0,
      '&:disabled': {
        cursor: 'not-allowed',
        borderColor: colors.gray,
        color: colors.white,
        backgroundColor: colors.gray,
        boxShadow: 'none',
      },
      '& span': {
        fontSize: '18px',
      },
      '&:hover': {
        backgroundColor: colors.orangeA100,
        color: colors.white01,
        cursor: 'pointer',
        '&:disabled': {
          cursor: 'not-allowed',
          borderColor: colors.blueGray,
          color: colors.white,
          backgroundColor: colors.blueGray,
          boxShadow: 'none',
        },
      },
    },
    delete: {
      backgroundColor: colors.red,
      color: 'white',
    },
    active: {
      backgroundColor: colors.teal600,
      color: 'white',
    },
    deActive: {
      backgroundColor: colors.gray02,
    },
  })
);
interface Props extends ButtonProps {
  children: any;
  ghost?: boolean;
  danger?: boolean;
  onClick?: any;
  htmlType?: any;
  isLoading?: boolean;
  customColor?: 'danger' | 'success' | 'warning';
}

const Button = memo<Props>(
  ({
    children,
    danger,
    ghost,
    htmlType,
    onClick,
    isLoading,
    customColor,
    ...rest
  }) => {
    const classes = useStyle();
    const { colors } = useThemes();

    const classNames = {
      danger: classes.delete,
      success: classes.active,
      warning: classes.deActive,
      default: '',
    };

    return (
      <AntButton
        onClick={onClick}
        htmlType={htmlType}
        className={`${classes.button} ${
          classNames[customColor || 'default']
        }`}
        {...{ ghost, danger }}
        {...rest}
      >
        {isLoading && (
          <Flex
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              backgroundColor: colors.black + '50',
              zIndex: 1,
            }}
            align="center"
            gap="middle"
          >
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 34, color: colors.blue }}
                  spin
                />
              }
            />
          </Flex>
        )}
        {children}
      </AntButton>
    );
  }
);

export { Button };
